import React from 'react'

/**
 * A value/bar that is either a pulsing placeholder (loading), a dash/flat
 * track (last load failed, nothing to show) or the real content - same
 * footprint in all three cases. Used by both the sidebar card and the
 * detail modal so switching states never changes their height.
 */
export const ValueSlot = ({ busy, hasError, width = 'w-10', heightClass = 'h-2.5', children }) => {
  if (busy) return <span className={`inline-block ${heightClass} ${width} rounded bg-gray-200 dark:bg-gray-700 animate-pulse align-middle`} />
  if (hasError) return <span className="text-gray-300 dark:text-gray-600">—</span>
  return children
}

export const BarSlot = ({ busy, hasError, heightClass, children }) => {
  if (busy) return <div className={`${heightClass} rounded-full bg-gray-200 dark:bg-gray-700 animate-pulse`} />
  if (hasError) return <div className={`${heightClass} rounded-full bg-gray-200 dark:bg-gray-700`} />
  return children
}
